import { IRebateProgressData } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const rebateProgressAdapter: EntityAdapter<IRebateProgressData> = createEntityAdapter<IRebateProgressData>({
	selectId: progress => progress.accountId
});